import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconArrow = ({
  direction = 'down',
  ...props
}: SvgIconProps & {
  direction?: 'right' | 'left' | 'up' | 'down'
}) => {
  let rotateValue

  switch (direction) {
    case 'down': {
      rotateValue = 'rotate(0deg)'
      break
    }
    case 'up': {
      rotateValue = 'rotate(180deg)'
      break
    }
    case 'right': {
      rotateValue = 'rotate(-90deg)'
      break
    }
    case 'left': {
      rotateValue = 'rotate(90deg)'
      break
    }
  }

  return (
    <SvgIcon {...props} viewBox="0 0 24 24" sx={{ transform: rotateValue }}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 16C11.744 16 11.488 15.902 11.293 15.707L6.29301 10.707C5.90201 10.316 5.90201 9.68401 6.29301 9.29301C6.68401 8.90201 7.31601 8.90201 7.70701 9.29301L12 13.586L16.293 9.29301C16.684 8.90201 17.316 8.90201 17.707 9.29301C18.098 9.68401 18.098 10.316 17.707 10.707L12.707 15.707C12.512 15.902 12.256 16 12 16Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}
